const ErrorMessageComponent = () => {
  return (
    <div>
      <h2>UPS, SOMETHING WENT WRONG</h2>
      <img src="./images/404error.png" alt="rick and morty scared" />
      <span>TRY AGAIN</span>
    </div>
  );
};

export default ErrorMessageComponent;
